export default "__VITE_ASSET__CGG4vbuG__"